<h2 mat-dialog-title>Input Value [{{vm.label}}]</h2>

<mat-dialog-content>

    <div class="p-4">

        <form (formValueChange)="formValue.set($event)"
              (formValid)="formValid.set($event)"
              (formDirty)="formDirty.set($event)">

            <div class="mce-form-section">

                @if (vm.showStringInput) {
                <div class="mce-form-field-group">
                    <mat-form-field class="w-full">
                        <mat-label>{{vm.label}}</mat-label>
                        <input matInput placeholder={{vm.placeHolder}}
                               name="value"
                               [ngModel]="vm.formValue.value"
                               required
                               #value=ngModel />
                        @if (vm.hintText) {
                        <mat-hint>{{vm.hintText}}</mat-hint>
                        }
                        <mat-error>
                            @if (value.hasError('required')) { An input is required }
                        </mat-error>
                    </mat-form-field>
                </div>
                }

                @if (vm.showNumberInput){
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>{{vm.label}}</mat-label>
                        <input matInput type="number" placeholder={{vm.placeHolder}}
                               name="value"
                               [ngModel]="vm.formValue.value"
                               required min={{vm.min}} max={{vm.max}}
                               #value=ngModel />
                        @if (vm.hintText) {
                        <mat-hint>{{vm.hintText}}</mat-hint>
                        }
                        <span matSuffix></span>
                        <mat-error>
                            @if (value.hasError('required')) { Value is required }
                            @if (value.hasError('max')) { Value needs to be <= {{vm.max}} }
                            @if (value.hasError('min')) { Value needs to be >= {{vm.min}} }
                        </mat-error>
                    </mat-form-field>
                </div>
                }


            </div>
        </form>


    </div>
</mat-dialog-content>

<mat-dialog-actions>

    <div class="w-full">
        <mce-save-cancel
            [config]="saveCancelConfig()"
            (action)="onSaveCancelAction($event)">
        </mce-save-cancel>
    </div>


</mat-dialog-actions>
